import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import React from 'react';
import { Toast } from 'primereact/toast';
import classNames from 'classnames';
import { Calendar } from 'primereact/calendar';
import { utcToZonedTime } from 'date-fns-tz';
import { formatISO } from 'date-fns';
import { useHistory } from "react-router-dom";

export const RegisterPage = () => {

    const [name, setName] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [businessTitle, setBusinessTitle] = React.useState(null);
    const [roleName, setRoleName] = React.useState('');
    const [username, setUsername] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');
    const [birthDate, setBirthDate] = React.useState(null);
    const [submitted, setSubmitted] = React.useState(false);

    const businessTitleOption = [
        { name: 'Travel', code: 'travel' },
        { name: 'Eduction', code: 'eduction' },
        { name: 'Sport', code: 'sport' }
    ];

    const roleNameOption = [
        {name: 'Admin', code: 'ADMIN'},
        {name: 'User', code: 'USER'}
    ];

    let history = useHistory();
    const toast = React.useRef();

    const showSuccess = (msg) => {
        toast.current.show({ severity: 'success', summary: 'Success', detail: msg, life: 3000 });
    };

    const showFailed = (msg) => {
        toast.current.show({ severity: 'error', summary: 'Failed', detail: msg, life: 3000 });
    };

    const showError = (msg) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: msg, life: 3000 });
    };

    function cleanForm() {
        setName('');
        setEmail('');
        setPhone('');
        setBusinessTitle('');
        setRoleName('');
        setUsername('');
        setPassword('');
        setConfirmPassword('');
        setBirthDate('');
        setSubmitted(false);
    }

    async function clickSubmit(event) {
        event.preventDefault();
        setSubmitted(true);
        if(!name || !email || !phone || !businessTitle || !roleName || !username || !password || !birthDate || !confirmPassword) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Form registrasi tidak boleh ada yang kosong', life: 3000 });
        } else if(password !== confirmPassword) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Password dan Confirm Password tidak sama', life: 3000 });
        } else {
            const zonedDate = utcToZonedTime(birthDate, "Asia/Jakarta");
            const birthDateConverted = formatISO(zonedDate, { representation: "complete" });

            const requestPayload = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*' 
                },
                body: JSON.stringify({
                  name: name,
                  phone: phone,  
                  email: email,
                  businessTitle: businessTitle.code,
                  roleName: roleName.code,
                  username: username,
                  password: password,
                  birthDate: birthDateConverted
                })
            }
            
            const response = await fetch('https://springboot-widy-app.widyan123.site/widy-app/users/registration', requestPayload);        
            const res = await response.json();
            console.log('response', res);
            if(response.status >= 200 && response.status <= 299) {                
                showSuccess(res.message);
                cleanForm();
                setTimeout(() => {
                    history.push('/confirm-register');
                }, 2000)
            } else if(response.status >= 400 && response.status <= 499) {
                showFailed(res.message);
            } else {
                showError(res.message);
            }
        }
    } 

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <h5>Register Page</h5>
                    <p>Use this page to start from scratch and place your custom content.</p>
                </div>
                <div className="card p-fluid">
                    <form onSubmit={clickSubmit}>
                        <div className="field">
                            <label htmlFor="name">Name</label>
                            <InputText id="name" type="text" value={name} onChange={(e) => setName(e.target.value)} className={classNames({ 'p-invalid': submitted && !name })} />
                            {submitted && !name && <small className="p-error">Enter your name</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="birthDate">Birth Date</label>
                            <Calendar showIcon monthNavigator yearNavigator yearRange="1990:2050" dateFormat="dd-mm-yy" value={birthDate} onChange={(e) => setBirthDate(e.value)} className={classNames({ 'p-invalid': submitted && !birthDate })}></Calendar>
                            {submitted && !birthDate && <small className="p-error">Enter your birth date</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="email">Email</label>
                            <InputText id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={classNames({ 'p-invalid': submitted && !email })} />
                            {submitted && !email && <small className="p-error">Enter your email</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="phone">Phone</label>
                            <InputText id="phone" type="text" value={phone} onChange={(e) => setPhone(e.target.value)} className={classNames({ 'p-invalid': submitted && !phone })} placeholder="+62" />
                            {submitted && !phone && <small className="p-error">Enter your phone</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="businessTitle">Business Title</label>
                            <Dropdown id="businessTitle" value={businessTitle} onChange={(e) => setBusinessTitle(e.value)} options={businessTitleOption} optionLabel="name" placeholder="Select One" className={classNames({ 'p-invalid': submitted && !businessTitle })}></Dropdown>
                            {submitted && !businessTitle && <small className="p-error">Enter your business title</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="roleName">Role Name</label>
                            <Dropdown id="roleName" value={roleName} onChange={(e) => setRoleName(e.value)} options={roleNameOption} optionLabel="name" placeholder="Select One" className={classNames({ 'p-invalid': submitted && !roleName })}></Dropdown>
                            {submitted && !roleName && <small className="p-error">Enter your role name</small>}
                        </div>     
                        <div className="field">
                            <label htmlFor="username">Username</label>
                            <InputText id="username" type="text" value={username} onChange={(e) => setUsername(e.target.value)} className={classNames({ 'p-invalid': submitted && !username })} />
                            {submitted && !username && <small className="p-error">Enter your username</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="password">Password</label>
                            <InputText  id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={classNames({ 'p-invalid': submitted && !password })} />
                            {submitted && !password && <small className="p-error">Enter your password</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="confirmPassword">Confirm Password</label>
                            <InputText  id="confirmPassword" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className={classNames({ 'p-invalid': submitted && !confirmPassword })} />
                            {submitted && !confirmPassword && <small className="p-error">Enter your confirm password</small>}
                        </div>
                        <Button label="Submit" className="p-button-success mr-2" />
                    </form>                    
                </div>
            </div>
        </div>
    );
}
